import { gql } from '@/utilities/gql';

const HOLDING_FRAGMENT = gql(`
  fragment holdingFields on Holding @_unmask {
    id
    units
    currencyISO
    transactionsStatus
    providerCurrencyISO
    averagePurchasePrice
    totalCost
    updatedAt
    manuallyMatched
    partiallyMatched
    symbol
    isAnalysisRestricted
    analysis {
      value
      valueUSD
      roi
      roiValue
      fairValue
      allocation
      capitalInvested
      return7d
      return7dValue
      return3m
      return3mValue
      return1y
      return1yValue
    }
    company {
      id
      name
      canonicalURL
      exchangeCountryISO
      tickerSymbol
      exchangeSymbol
      uniqueSymbol
      info {
        url
      }
      data {
        currencyInfo
      }
      score {
        value
        future
        past
        health
        dividend
        sentence
        total
      }
      analysisDividend {
        dividendYield
      }
      analysisFuture {
        forwardPe1Y
        forwardPriceToSales1Y
        revenueGrowthAnnual
        netIncomeGrowthAnnual
      }
      analysisHealth {
        netIncome
      }
      analysisValue {
        pe
        pb
        priceToSales
        preferredRelativeMultiple
        lastSharePrice
        npvPerShare
        marketCapUSD
        intrinsicDiscount
        priceTarget
        priceTargetAnalystCount
        return7d
        return30d
        return90d
        return1yAbs
      }
      analysisMisc {
        analystCount
      }
    }
  }
`);

const INVALID_HOLDING_FRAGMENT = gql(`
  fragment invalidHoldingFields on Holding @_unmask {
    id
    symbol
    units
    company {
      name
      uniqueSymbol
      info {
        url
      }
    }
  }
`);

const ROOT_PORTFOLIO_FRAGMENT = gql(`
  fragment rootPortfolioFields on Portfolio @_unmask {
    id
    name
    createdAt
    currencyISO
    manualInputOption
    updatedAt
    type
    isAnalysisRestricted
    provider {
      name
    }
    link {
      brokerageName
      status
      unmatchedTickers
      unmatchedHoldings {
        id
        symbol
        providerCompanyName
      }
    }
    analysis {
      id
      value
      roi
      roiValue
      return7d
      return1y
      marketCountryISO
      capitalInvested
      estimatedDividendYield
      estimatedYearlyDividend
      risksCount
      rewardsCount
      realisedReturn
      dividendPaid
      currencyReturn
      totalReturn
      realisedReturnPercent,
      dividendPaidPercent,
      currencyReturnPercent,
      totalReturnPercent,
    }
    snowflake {
      description
      scores {
        value
        future
        past
        health
        dividend
      }
    }
  }
`);

const NARRATIVE_FRAGMENT = gql(`
  fragment narrativeFields on Holding @_unmask {
    company {
      myValuation {
        id
        fairValue
        type
        narrative {
          id
          author {
            id
            displayName
            name
            imageUrl
          }
          updatedAt
          title
        }
      }
      defaultNarrative {
        id
        title
        updatedAt
        valuation {
          id
          fairValue
          type
        }
        author {
          displayName
          name
          imageUrl
        }
      }
    }
  }
`);

export const PORTFOLIO_FRAGMENT = gql(
  `
  fragment portfolioFields on Portfolio @_unmask {
    ...rootPortfolioFields
    holdings {
      ...holdingFields
      ...narrativeFields
    }
    invalidHoldings {
      ...invalidHoldingFields
    }
  }
  
`,
  [
    ROOT_PORTFOLIO_FRAGMENT,
    HOLDING_FRAGMENT,
    INVALID_HOLDING_FRAGMENT,
    NARRATIVE_FRAGMENT,
  ]
);
